import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { pad } from 'helpers/formatters';
import CardIcon from 'billing/CardIcon';

import paymentMethodsDecorator from '../decorator';
import { setDefault, destroy } from '../actions';
import { getUser, getDeletePaymentMethodStatus } from 'reducers';

import styles from './index.module.css';
import default_card from './default_card.svg';
import remove_card from './remove_card.svg';
import add_card from './add_card.svg';
import CircleLoader from '../../../common/CircleLoader';
import WarningModal from '../../../common/WarningModal';


export class SelectPaymentMethod extends React.Component {
  state = {
    isDeleteModalOpen: false,
    deletedPaymentMethodId: null,
  }

  handleOpenDeleteModal = (e, id) => {
    e.stopPropagation();
    this.setState({
      isDeleteModalOpen: true,
      deletedPaymentMethodId: id,
    });
  }

  handleCloseDeleteModal = (e) => {
    this.setState({
      isDeleteModalOpen: false,
      deletedPaymentMethodId: null,
    });
  }

  deletePaymentMethod = () => {
    const {
      user,
      destroy
    } = this.props
    const { deletedPaymentMethodId } = this.state;
    destroy(user.id, deletedPaymentMethodId);
    this.handleCloseDeleteModal();
  }
  
  render() {
    const {
      paymentMethods,
      setDefault,
      onNewCard,
      deleteStatuses,
      user,
    } = this.props;
    const { isDeleteModalOpen, deletedPaymentMethodId } = this.state;

    const userCanDeletePaymentMethod = user && user.acl_group_name !== 'BUSINESS' && user.acl_group_name !== 'RESELLER';
    const deletingMethod = deletedPaymentMethodId && paymentMethods.find(p => p.id === deletedPaymentMethodId);
    const deletingMethodLastFour = deletingMethod ? deletingMethod.card_last_four : ''

    if (!paymentMethods) { return null; }

    return (
      <div className={styles.SelectPaymentMethod}>
        {paymentMethods.map(card => {
          const deleting = deleteStatuses[card.id] && deleteStatuses[card.id] === 'PENDING';
          return (
            <div
              onClick={() => setDefault(card.id)}
              className={cn(styles.card, !card.is_default && styles.selectable)}
            >
              {card.is_default &&
                <div className={styles.isDefault}>
                  <img src={default_card} alt="default" />
                </div>
              }
              {userCanDeletePaymentMethod && !card.is_default && !deleting &&
                <div className={styles.removeCard}>
                  <img
                    src={remove_card}
                    alt="remove this card"
                    onClick={e => this.handleOpenDeleteModal(e, card.id)}
                  />
                </div>
              }
              <div className={styles.brand}>
                <CardIcon cardType={card.card_brand} color="light" />
              </div>
              <div className={styles.lastFour}>
                **** **** **** {card.card_last_four}
              </div>
              <div className={styles.expiration}>
                {pad(card.expiration_month, 2)}/{card.expiration_year}
              </div>
              {deleting && (
                <div
                  className={styles.loaderWrapper}
                  onClick={(e) =>  {
                    e.stopPropagation();
                  }}
                >
                  <CircleLoader className={styles.loader} showLoader={deleting} />
                </div>
              )}
            </div>
          )
        })}
         
        <div className={cn(styles.card, styles.addCard)} onClick={onNewCard}>
          <div className={styles.addCardLabel}>
            <img src={add_card} alt="" />
            Add Payment Method
          </div>
        </div>
        <WarningModal
          isOpen={isDeleteModalOpen}
          title="Delete payment method"
          text={`Are you sure you want to delete the payment method *${deletingMethodLastFour}?`}
          onClose={this.handleCloseDeleteModal}
          onConfirm={this.deletePaymentMethod}
          noText="No"
        />
      </div>
    )
  }
}

const mapStateToProps = (state, { paymentMethods }) => {
  const user = getUser(state);
  const deleteStatuses = paymentMethods && paymentMethods.reduce((acc, method) => {
    const status = getDeletePaymentMethodStatus(state, method.id);
    acc[method.id] = status;
    return acc;
  }, {});

  return {  
    user,
    deleteStatuses,
  }
}

const mapDispatchToProps = {
  setDefault,
  destroy
}

export default paymentMethodsDecorator(connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectPaymentMethod));
